import React, { useCallback, useMemo } from 'react'
import { RowSortable } from './RowSortable'
import type { TableProps } from './index'

export const TableContent = ({
  onSelect,
  head,
  dataArray,
  className,
  foot,
  tableClassName,
  responsive,
  'aria-rowcount': ariaRowCount,
  ...rest
}: TableProps) => {
  const [currentItem, setCurrentItem] = React.useState(null)

  const computedTableClassName = useMemo(() => tableClassName || 'table table-hover table-striped', [tableClassName])

  const handleSelect = useCallback(
    (item) => {
      setCurrentItem(item)
      onSelect?.(item)
    },
    [onSelect]
  )

  const rowSortableProps = useMemo(
    () => ({
      onSelect,
      head,
      className,
      foot,
      dataArray,
      tableClassName: computedTableClassName,
      currentItem,
      handleSelect,
      ...rest,
    }),
    [onSelect, head, className, foot, dataArray, computedTableClassName, currentItem, handleSelect, rest]
  )

  const table = (
    <table className={computedTableClassName} aria-rowcount={ariaRowCount}>
      {head}
      <RowSortable {...rowSortableProps} />
      {foot}
    </table>
  )

  // `responsive` wraps in Bootstrap's scroll container, same truthy-only convention as
  // `ScrollableContent` (libs/webui/data-tools/src/Table/ScrollableContent.tsx:17) — the string
  // value itself is never used as a `table-responsive-{sm,md,...}` breakpoint suffix there either,
  // so this path stays consistent rather than inventing new semantics for the prop.
  return responsive ? <div className="table-responsive">{table}</div> : table
}
